import React from 'react';
import '../styles/WalletConnect.css';

function WalletConnect({ onConnect, contractAddress }) {
  return (
    <div className="wallet-connect">
      <div className="hero-section">
        <h2>Lock your stablecoins.<br />Set a date.<br />Nobody can touch them until then.</h2>
        <p className="hero-subtitle">Not even us. That's the point.</p>
        <button onClick={onConnect} className="btn-connect">
          Connect Wallet
        </button>
      </div>

      <div className="how-it-works">
        <h3>How it works</h3>
        <div className="steps">
          <div className="step">
            <div className="step-number">1</div>
            <div className="step-content">
              <strong>Choose & Lock</strong>
              <span>Pick a stablecoin, set an amount and lock duration</span>
            </div>
          </div>
          <div className="step">
            <div className="step-number">2</div>
            <div className="step-content">
              <strong>Funds Secured</strong>
              <span>Your tokens are held by the smart contract — no one has access</span>
            </div>
          </div>
          <div className="step">
            <div className="step-number">3</div>
            <div className="step-content">
              <strong>Withdraw</strong>
              <span>When the time is up, only you can withdraw to your wallet</span>
            </div>
          </div>
        </div>
      </div>

      <div className="trust-badges">
        <div className="trust-badge">
          <span className="trust-icon">🛡️</span>
          <div>
            <strong>Non-Custodial</strong>
            <span>We never control your funds</span>
          </div>
        </div>
        <div className="trust-badge">
          <span className="trust-icon">✓</span>
          <div>
            <strong>Verified Code</strong>
            <span>
              {contractAddress ? (
                <a href={`https://sepolia.etherscan.io/address/${contractAddress}#code`} target="_blank" rel="noopener noreferrer">
                  Read on Etherscan →
                </a>
              ) : 'Open source smart contract'}
            </span>
          </div>
        </div>
        <div className="trust-badge">
          <span className="trust-icon">🎫</span>
          <div>
            <strong>NFT Receipt</strong>
            <span>Proof of every lock in your wallet</span>
          </div>
        </div>
        <div className="trust-badge">
          <span className="trust-icon">🔐</span>
          <div>
            <strong>No Admin Keys</strong>
            <span>Nobody can drain or freeze funds</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WalletConnect;
